import ReactGA from "react-ga4";

const measurementId = process.env.REACT_APP_GA_ID;

export const initGA = () => {
    ReactGA.initialize(measurementId, { debug: true });
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};